var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSphereLogo = function SvgSphereLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 24,
    fill: "none",
    viewBox: "0 0 102 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sphere-logo_svg__a)",
    d: "M11.753 1.4c-5.856 0-10.62 4.764-10.62 10.62 0 5.857 4.764 10.621 10.62 10.621 5.857 0 10.62-4.764 10.62-10.62 0-5.857-4.763-10.621-10.62-10.621",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.682 15.322c.548 1.508 2.508 2.31 5.074 2.31 1.696 0 3.656-.35 5.65-1.076 5.011-1.823 8.335-5.333 7.421-7.838h.002a9.658 9.658 0 0 0-18.151 6.604h.004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.038 13.557c-1.503 1.587-3.74 2.976-6.303 3.906-2.037.742-4.106 1.134-5.98 1.134-1.416 0-2.636-.224-3.614-.64a9.64 9.64 0 0 0 7.61 3.718c5.332 0 9.656-4.323 9.656-9.655a7 7 0 0 0-.01-.348c-.319.628-.772 1.26-1.361 1.883z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sphere-logo_svg__b)",
    d: "M7.756 17.631c.65 0 1.338-.052 2.051-.156l-.035-.012c-2.562-.933-4.8-2.32-6.303-3.906-.59-.624-1.044-1.256-1.36-1.883q-.009.173-.01.347c0 1.16.204 2.273.579 3.302h.002c.548 1.508 2.508 2.308 5.074 2.308z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sphere-logo_svg__c)",
    d: "M11.753 18.067c-1.374.346-2.73.53-3.999.53-1.415 0-2.635-.225-3.613-.64a9.64 9.64 0 0 0 7.61 3.717 9.64 9.64 0 0 0 7.61-3.717c-.977.417-2.195.64-3.612.64-1.267 0-2.625-.184-3.998-.53z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F2A43",
    d: "m30.42 15.827 1.803-1.862c.631 1.363 1.848 1.772 3.38 1.772 1.33 0 2.074-.41 2.074-1.022 0-.523-.608-.84-2.254-1.18-3.517-.706-4.689-1.794-4.689-3.68 0-1.885 1.735-3.657 5.072-3.657 2.592 0 3.989.772 5.026 2.409l-1.915 1.634c-.653-1.18-1.555-1.772-3.067-1.772-1.263 0-2.028.5-2.028 1.091s.563.998 2.456 1.386c3.291.658 4.508 1.659 4.508 3.544 0 2.044-1.78 3.52-5.14 3.52-2.322 0-4.193-.636-5.228-2.181zM67.571 10.33v7.449h-3.087v-6.541c0-1.954-.834-2.589-2.005-2.589-1.308 0-2.592.864-2.592 3.135v5.995h-3.088V1.45h3.088v6.903c.72-1.453 2.028-2.158 3.63-2.158 2.343 0 4.056 1.386 4.056 4.133zM80.387 13.282h-7.98c.314 1.634 1.307 2.408 2.817 2.408 1.308 0 2.165-.5 2.48-1.408l2.523.932c-.72 1.817-2.456 2.794-5.003 2.794-3.742 0-5.86-2.181-5.86-5.905 0-3.723 2.052-5.905 5.68-5.905s5.432 2.134 5.432 5.86c0 .317-.044.932-.09 1.226zM72.385 11.1h5.252c-.248-1.704-1.195-2.612-2.615-2.612s-2.39.885-2.637 2.611M89.896 6.447l-.383 2.725c-.315-.203-.833-.34-1.42-.34-1.353 0-2.705.998-2.705 3.065v5.884H82.3V6.423h2.684V8.65c.587-1.566 1.937-2.453 3.696-2.453.495 0 .946.09 1.216.25M101.461 13.282h-7.98c.315 1.634 1.308 2.408 2.817 2.408 1.308 0 2.165-.5 2.48-1.408l2.524.932c-.721 1.817-2.456 2.794-5.004 2.794-3.742 0-5.86-2.181-5.86-5.905 0-3.723 2.052-5.905 5.68-5.905s5.432 2.134 5.432 5.86c0 .317-.044.932-.089 1.226zM93.46 11.1h5.252c-.249-1.704-1.195-2.612-2.616-2.612-1.42 0-2.39.885-2.636 2.611M54.947 12.08c0 3.723-2.486 5.928-5.46 5.928-1.667 0-3.099-.84-3.751-2.113v6.655h-3.088V6.423h3.088v1.944c.631-1.453 1.948-2.17 3.75-2.17 2.999 0 5.461 2.18 5.461 5.883m-2.898.023c0-2.316-1.629-3.52-3.275-3.52s-3.04 1.204-3.04 3.407v.227c0 2.157 1.416 3.406 3.04 3.406s3.275-1.204 3.275-3.52"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sphere-logo_svg__a",
    x1: 4.638,
    x2: 19.289,
    y1: 4.543,
    y2: 21.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C61F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DCBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sphere-logo_svg__b",
    x1: 10.73,
    x2: 10.73,
    y1: 11.674,
    y2: 21.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sphere-logo_svg__c",
    x1: 10.73,
    x2: 10.73,
    y1: 11.674,
    y2: 21.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgSphereLogo;